/** ISO calendar date (YYYY-MM-DD); April 18 = birthday. */
export const INITIAL_COUPONS = [
  {
    emoji: "🧗‍♂️",
    name: "Belay Buddy",
    description: "Climb rocks with a trained belay buddy.",
    status: "Claimed",
    active: false,
    received: "2023-04-18",
  },
  {
    emoji: "🧑‍🍳",
    name: "Fine Dining at Home",
    description:
      "Enjoy a home-cooked, 3-course meal featuring the cuisine of your choice.",
    status: "Claimed",
    active: false,
    received: "2023-04-18",
  },
  {
    emoji: "🐶",
    name: "Animal Meme",
    description: "Receive a mood boosting animal meme.",
    status: "♾️ Remaining",
    active: false,
    received: "2023-04-18",
  },
  {
    emoji: "🛀",
    name: "Banya Day",
    description: "Relax your body in the sauna and hot baths.",
    status: "Claimed",
    active: false,
    received: "2024-04-18",
  },
  {
    emoji: "👗",
    name: "Fashion Show",
    description:
      "Shop to replenish your retired clothes and put on an all-day fashion show.",
    status: "0.5 Remaining",
    active: true,
    received: "2024-04-18",
  },
  {
    emoji: "🌵",
    name: "Plant Pet",
    description: "Pick out a big plant and bring it home.",
    status: "Claimed",
    active: false,
    received: "2024-04-18",
  },
  {
    emoji: "👯‍♂️",
    name: "Dance Lesson",
    description: "Learn a new dance with your partner.",
    status: "Claimed",
    active: false,
    received: "2025-04-18",
  },
  {
    emoji: "🖼️",
    name: "Art Piece",
    description: "Get a large flowery art piece.",
    status: "1 Remaining",
    active: true,
    received: "2025-04-18",
  },
  {
    emoji: "👰‍♀️",
    name: "Get an 'I Do'",
    description: "Put a ring on it under the chuppah.",
    status: "Claimed",
    active: false,
    received: "2025-04-18",
  },
  {
    emoji: "🍝",
    name: "Italy Photos",
    description:
      "Relive our favorite meals and memories from our travels through Italy in a photo book.",
    status: "1 Remaining",
    active: true,
    received: "2026-04-18",
  },
  {
    emoji: "🏯",
    name: "Japan Photos",
    description:
      "Sushi conveyor belts, beautiful gardens, and Don Quijote captured in a photo book. Arigatō gozaimasu.",
    status: "1 Remaining",
    active: true,
    received: "2026-04-18",
  },
  {
    emoji: "🇹🇭",
    name: "Honeymoon Photos",
    description:
      "Can a photo book capture the honeymoon love? Find out.",
    status: "1 Remaining",
    active: true,
    received: "2026-04-18",
  },
].sort((a, b) => {
  const d = a.received.localeCompare(b.received);
  return d !== 0 ? d : a.name.localeCompare(b.name);
});
